module.exports = __webpack_public_path__ + "img/icon_quick_close.13d241ca.svg";